const React = require("react");
const {openPopupWindow} = require("../../../../../../../emitters/popup");
const RefundFormStart = require('../components/RefundFormStart');

module.exports = (refund, update) => openPopupWindow((setPopupState, popup) => {
  const {close} = popup;

  return (stateOfPopup) => {
    return (
      <RefundFormStart
        caption="Begin Customer Refund"
        state={stateOfPopup}
        setState={setPopupState}
        close={close}
        update={update}
        issue_id={refund.id}
      />
    );
  };
});
